import { useCallback, useMemo } from 'react'
import type { MentionItem, RichTextMentionsConfig } from '@firstbite/ui'
import { useUserOptions } from 'services/users'
import { useAuth } from 'context/authentication/useAuth'

/**
 * `mentions` config for the fb-ui note composer/editor on the entity detail
 * pages — the active teammates (excluding the current user), capped to 5,
 * matching the legacy Quill editor's `@`-mention list. Selecting inserts a
 * `<span class="mention" data-id=…>` token that the backend parses for
 * notifications, so no separate mentions payload is sent.
 */
export function useNoteMentions(): RichTextMentionsConfig {
  const { data: users } = useUserOptions({ onlyActive: true })
  const { user } = useAuth()

  const search = useCallback(
    (query: string): MentionItem[] => {
      const q = query.trim().toLowerCase()
      return (users ?? [])
        .filter((u) => u.value !== user?.id)
        .filter((u) => !q || u.label.toLowerCase().includes(q))
        .slice(0, 5)
        .map((u) => ({ id: u.value, label: u.label }))
    },
    [users, user?.id]
  )

  return useMemo(() => ({ search }), [search])
}
